import { useDesignMaxTheme } from "@/packages";
import { Center, Flex, Grid, Text } from "@chakra-ui/react";
import { type onNavigateProps } from "@shared/client";
import { FONT } from "@styles/common";
import { useState } from "react";
import { Button } from "../button";
import { CurrentDates, WeekDays } from "./components";
import { useCalendar, useCheckDate } from "./hooks";

export const Calendar = ({ onNavigate }: { onNavigate: ({ path, params }: onNavigateProps) => void }) => {
    const [monthOffset, setMonthOffset] = useState(0);
    const { fullCalendar } = useCalendar({ modeLength: 2, offSet: monthOffset });
    const { checkIn, checkOut, currentObj, maxDate, onChangeColor } = useCheckDate();
    const { COLORS, MEDIAS } = useDesignMaxTheme();
    const { isMobile } = MEDIAS();

    const onPrevMonth = () => {
        setMonthOffset((prev) => prev - 1);
    };

    const onNextMonth = () => {
        setMonthOffset((prev) => prev + 1);
    };

    const isDisabled = monthOffset <= 0;

    return (
        <Center
            w={isMobile ? "320px" : "904px"}
            h={isMobile ? "auto" : "504px"}
            alignItems={isMobile ? "flex-start" : "center"}
            p={isMobile ? "32px 0" : "0"}
            overflow={isMobile ? "auto" : "initial"}
        >
            <Center position="relative">
                <Flex
                    position="absolute"
                    w={isMobile ? "100%" : "720px"}
                    top={isMobile ? "auto" : "0"}
                    bottom={isMobile ? "-108px" : "auto"}
                    pb={isMobile ? "32px" : "auto"}
                    justifyContent="space-between"
                    columnGap={isMobile ? "8px" : ""}
                    sx={{
                        "& > button": {
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            p: "0 16px",
                            bgColor: isDisabled ? COLORS.gray[300] : COLORS.none,
                            cursor: "pointer",
                            w: isMobile ? "100%" : "64px",
                            h: isMobile ? "48px" : "24px",
                        },
                    }}
                >
                    <Button onClick={onPrevMonth}>PREV</Button>
                    <Button onClick={onNextMonth}>NEXT</Button>
                </Flex>
                <Grid gridGap="24px" templateColumns={isMobile ? "repeat(1, 1fr)" : "repeat(2, 1fr)"}>
                    {fullCalendar?.map((cal) => {
                        const { calendar, title } = { ...cal };
                        const { month, year } = { ...title };

                        return (
                            <Flex key={month} flexDir="column" rowGap="24px">
                                <Text textAlign="center" sx={{ ...FONT("pretendard", 16, 500) }}>
                                    {year}년 {month.toString().padStart(2, "0")}월
                                </Text>
                                <Flex flexDir="column" rowGap="8px">
                                    <WeekDays />
                                    <CurrentDates
                                        calendar={calendar}
                                        title={{ year, month }}
                                        checkIn={checkIn}
                                        checkOut={checkOut}
                                        currentObj={currentObj}
                                        maxDate={maxDate}
                                        onChangeColor={onChangeColor}
                                        onNavigate={onNavigate}
                                    />
                                </Flex>
                            </Flex>
                        );
                    })}
                </Grid>
            </Center>
        </Center>
    );
};
